'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.AgentService = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _utils = require('../webComponents/utils');

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var log = (0, _utils.getLog)('[AgentService]');

var AgentService = exports.AgentService = function () {
    function AgentService($rootScope, $location) {
        var _this = this;

        _classCallCheck(this, AgentService);

        this.storage = window.localStorage;
        this.officeID = 0;
        this.clerkID = 0;
        this.timestamp = null;
        this.tryLoad();
        $rootScope.$on('$locationChangeStart', function () {
            return _this.update($location);
        });
    }

    _createClass(AgentService, [{
        key: 'update',
        value: function update($location) {
            var params = $location.search();
            if (!params) {
                log.error('Failed to get $location.search.');
                return;
            }

            if (params.ao !== undefined && params.ac !== undefined) {
                this.set('URL', params.ao, params.ac, Date.now());
            }
        }
    }, {
        key: 'set',
        value: function set(source, officeID, clerkID, timestamp) {
            var oldOfficeID = this.officeID;
            var oldClerkID = this.clerkID;
            var oldTimestamp = this.timestamp;

            this.officeID = _.toInteger(officeID);
            this.clerkID = _.toInteger(clerkID);
            this.timestamp = timestamp;

            if (this.officeID != oldOfficeID || this.clerkID != oldClerkID || this.timestamp != oldTimestamp) {
                log('Agent set from ' + source + ':', oldOfficeID, oldClerkID, oldTimestamp, '=>', this.officeID, this.clerkID, this.timestamp);
                this.store();
            }
        }
    }, {
        key: 'store',
        value: function store() {
            if (this.officeID === 0 && this.clerkID === 0) {
                // Default agent, so don't bother to keep anything saved.
                this.storage.removeItem('agent');
            } else {
                // No-default agent - save it.
                this.storage.setItem('agent', JSON.stringify({
                    officeID: this.officeID,
                    clerkID: this.clerkID,
                    timestamp: this.timestamp
                }));
            }
        }
    }, {
        key: 'tryLoad',
        value: function tryLoad() {
            try {
                var json = this.storage.getItem('agent');
                if (!json) return;
                var agent = JSON.parse(json);
                this.set('storage', agent.officeID, agent.clerkID, agent.timestamp);
            } catch (e) {
                log.error('Load failed:', e);
            }
        }
    }]);

    return AgentService;
}();

AgentService.$inject = ['$rootScope', '$location'];


//////////////////
// WEBPACK FOOTER
// ./src/winresCloud/agentService.js
// module id = 668
// module chunks = 2